module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"open_task":"Opening Task"},"th":{"open_task":"กำลังเปิดงาน"}}')
  delete Component.options._Ctor
}
